<template>
  <bottom-sheet :open="open" title="راهنمای عکس‌برداری" sheet-class="guide" @close="$emit('close')">
    <div class="gd-scroll">
      <div class="gd-head">
        <h2>راهنمای عکس‌برداری</h2>
        <p>لطفاً با رعایت چهارچوب‌های مشخص‌شده تصویر خود را ارسال نمایید.</p>
      </div>

      <div class="gd-cols">
        <div class="gd-col ok">
          <div class="gd-lbl ok"><base-icon name="check" :width="2.6" />عکس صحیح</div>
          <img class="gd-img" src="/files/True01.jpg" alt="نمونه‌ی عکس صحیح" loading="lazy" />
          <ul class="gd-list">
            <li v-for="item in doList" :key="item">{{ item }}</li>
          </ul>
        </div>

        <div class="gd-col bad">
          <div class="gd-lbl bad"><base-icon name="close" :width="2.6" />عکس نادرست</div>
          <img class="gd-img" src="/files/False05.jpg" alt="نمونه‌های عکس نادرست" loading="lazy" />
          <ul class="gd-list">
            <li v-for="item in dontList" :key="item">{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="sh-foot">
      <button class="btn btn-primary" type="button" @click="$emit('close')">متوجه شدم</button>
    </div>
  </bottom-sheet>
</template>

<script>
import BottomSheet from "./BottomSheet.vue";
import BaseIcon from "./BaseIcon.vue";

/**
 * Side-by-side "correct vs incorrect" photo examples.
 *
 * Two columns rather than a list, because the failure modes (glasses, mask, tilted head,
 * backlight) are visual and a photo settles them faster than a sentence does.
 */
export default {
  name: "PhotoGuideSheet",
  components: { BottomSheet, BaseIcon },

  props: {
    open: { type: Boolean, default: false },
  },

  data() {
    return {
      doList: ["چهره مستقیم رو به دوربین", "نور کافی روی صورت", "بدون عینک و ماسک", "کل صورت داخل کادر"],
      dontList: ["داشتن عینک", "داشتن ماسک", "کج یا چرخیده بودن سر", "نور کم یا از پشتِ سر"],
    };
  },
};
</script>

<style scoped>
.gd-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 0 20px 6px;
}

.gd-head {
  margin-bottom: 16px;
}

.gd-head h2 {
  margin: 0 0 6px;
}

.gd-cols {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.gd-col {
  display: flex;
  flex-direction: column;
}

.gd-lbl {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 800;
  margin-bottom: 8px;
}

.gd-lbl >>> svg {
  width: 17px;
  height: 17px;
  flex: 0 0 auto;
}

.gd-lbl.ok {
  color: var(--success);
}

.gd-lbl.bad {
  color: var(--danger);
}

.gd-img {
  width: 100%;
  display: block;
  border-radius: 12px;
  border: 2px solid var(--border);
}

.gd-col.ok .gd-img {
  border-color: var(--success);
}

.gd-col.bad .gd-img {
  border-color: var(--danger);
}

.gd-list {
  list-style: none;
  margin: 11px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.gd-list li {
  position: relative;
  padding-inline-start: 16px;
  font-size: 12.5px;
  color: var(--foreground);
  line-height: 1.55;
}

.gd-list li::before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  top: 7px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.gd-col.ok .gd-list li::before {
  background: var(--success);
}

.gd-col.bad .gd-list li::before {
  background: var(--danger);
}
</style>

<style>
/* The guide sheet scrolls its body under a sticky footer, which needs the sheet element
   itself to become a flex column — a rule that has to reach BottomSheet's root. */
.sheet.guide {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 10px 0 0;
}

.sheet.guide .grab {
  margin: 4px auto 12px;
}

.sheet.guide .sh-foot {
  flex: 0 0 auto;
  background: var(--card);
  border-top: 1px solid var(--border);
  padding: 12px 20px calc(14px + env(safe-area-inset-bottom));
  margin-top: 0;
}
</style>
